import logoutUser from '../logout';
import gqlClient from '../client/gqlClient';
import gql from 'graphql-tag';

export const queryFollowersTiersList = async () => {
    try {
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        const result = await gqlClient.client.query({
            query: gql`
                query followersTiersList {
                    followersTiersList {
                        followersTiers {
                            id
                            name
                            label
                            description
                            targetingPrice
                            isContactSales
                        }
                    }
                }
            `
        });

        const {followersTiersList} = result.data;

        return followersTiersList ? followersTiersList.followersTiers : null;
    } catch (error) {
        if (error.message.includes('401')) {
            return logoutUser();
        }
        throw error;
    }
};



// WEBPACK FOOTER //
// ./graphql/queries/queryFollowersTiers.js